import React from "react";
import Availability from "../../DashboardPreferences/Availability";
import WorkingHours from "../../DashboardPreferences/WorkingHours";
import { useSelector } from "react-redux";

export default function CalenderAvailability() {
  const profile = useSelector(({ profile: { profiledata } }) => profiledata);

  return (
    <div className="calendaravailability">
      <div className="account-preference ">
        <Availability profile={profile} />
        <WorkingHours profile={profile} />
      </div>
      {/* <>
        <h5>Availability</h5>
        <div className="working-day">
          <h6>Working Days</h6>
          <p>Select the day you’ll work in a week</p>
          <div className="select-date">
            <h5>Sunday</h5>
            <h5 className="active">Monday</h5>
            <h5 className="active">Tuesday</h5>
            <h5 className="active">Wednesday</h5>
            <h5 className="active">Thursday</h5>
            <h5>Friday</h5>
            <h5>Saturday</h5>
          </div>
        </div>
        <div className="working-day">
          <h6>Working  hour</h6>
          <p>Select your working hour</p>
          <div className="form-group ">
            <input type="text" value="9:30am - 12:30pm" className="form-control" />
          </div>
          <div className="row">
            <div className="col-md-4 form-group">
              <label>From</label>
              <input type="time" className="form-control w-100" placeholder="Select start time" />
            </div>
            <div className="col-md-4 form-group">
              <label>To</label>
              <input type="time" className="form-control w-100" placeholder="Select end time" />
            </div>
            <div className="col-md-4 form-group">
              <label>&nbsp;</label>
              <button className="buttons background-button">Add time</button>
            </div>
          </div>
        </div>
      </> */}
    </div>
  );
}
